export default "__VITE_ASSET__CfxFqHTy__"